<content-block [isLoading]="mailLoader">
	<div class="modal-header">
		<h2 class="modal-title">
			{{ 'Labels.SendEmail' | translate }}
		</h2>

		<button type="button" class="modal-button-close fal fa-times" (click)="onClose()"></button>
	</div>
	<loader-spinner [model]="mailLoader"></loader-spinner>
	<upload-document-modal
		#uploadDocumentModal
		[evenementId]="evenementId"
		[isFromPageSaisie]="false"
		[forReUse]="true"
		[isAddModalWithoutType]="isAddModalWithoutType"
		[courrierFile]="courrierFile"
		[courrierId]="courrierId"
		[isFromFrontContactPage]="isFromFrontContactPage"
	>
	</upload-document-modal>

	<div class="modal-body">
		<div>
			<h3 translate="Documents.Form.Part3ForSendMail"></h3>
		</div>

		<form [formGroup]="form">
			<div class="row">
				<div class="col-6">
					<div class="form-group">
						<label class="form-label form-label-required" translate="Labels.Of"></label>
						<!-- <input id="field-sender" class="form-control" formControlName="sender" /> -->
						<ng-select
							*ngIf="!isFromFrontContactPage"
							labelForId="field-sender"
							formControlName="sender"
							appendTo="body"
							[class.is-invalid]="senderField.dirty && senderField.invalid"
							[searchable]="true"
							[placeholder]="'Forms.Placeholder.Select' | translate"
							[notFoundText]="'NgSelect.NotFoundText' | translate"
							[typeToSearchText]="'NgSelect.TypeToSearchText' | translate"
							[loadingText]="'NgSelect.LoadingText' | translate"
							[clearAllText]="'NgSelect.ClearAllText' | translate"
						>
							<ng-option *ngFor="let senderMail of senderList" [value]="senderMail">
								{{ senderMail }}
							</ng-option>
						</ng-select>
						<input
							[class.is-invalid]="senderField.dirty && senderField.invalid"
							*ngIf="isFromFrontContactPage"
							id="field-sender"
							class="form-control"
							formControlName="sender"
						/>
						<form-control-feedback style="position: absolute" [field]="senderField"></form-control-feedback>
					</div>
				</div>

				<div class="col-6">
					<div class="form-group">
						<label class="form-label form-label-required" translate="Labels.Receiver"></label>
						<input
							[class.is-invalid]="receiverField.dirty && receiverField.invalid"
							id="field-receiver"
							class="form-control"
							formControlName="receiver"
						/>
						<form-control-feedback style="position: absolute" [field]="receiverField"></form-control-feedback>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-6">
					<div class="form-group">
						<label class="form-label form-label-required" translate="Labels.ObjectMail"></label>
						<input
							[class.is-invalid]="subjectField.dirty && subjectField.invalid"
							id="field-subject"
							class="form-control"
							formControlName="subject"
							[maxlength]="200"
						/>
						<form-control-feedback style="position: absolute" [field]="subjectField"></form-control-feedback>
					</div>
				</div>

				<div class="col-6" *ngIf="evenementId || courrierId">
					<div class="form-group">
						<label class="form-label" translate="Labels.CC"></label>
						<ng-select
							#ccSelect
							formArrayName="ccReceivers"
							[placeholder]="'Forms.Placeholder.Select' | translate"
							(add)="onAddCCReceiver($event)"
							(remove)="onRemoveCCReceiver($event)"
							labelForId="field-cc"
							appendTo="body"
							[multiple]="true"
							[addTag]="true"
							[addTagText]="'Forms.Placeholder.AddEmail' | translate"
						>
							<ng-option *ngFor="let ccReciever of predefinedEmails" [value]="ccReciever">
								{{ ccReciever }}
							</ng-option>
						</ng-select>
						<i *ngIf="isCCEMailsOneOrManyError" style="position: absolute; font-size: 0.625rem; color: red">
							{{ 'ValidationErrors.WrongOneOrManyEmails' | translate }}
						</i>
					</div>
				</div>

				<div *ngIf="isFromFrontContactPage" class="form-group col-6" style="align-self: flex-end">
					<label for="field-checkboxCC" class="custom-checkbox" style="margin: 0">
						<input
							id="field-checkboxCC"
							type="checkbox"
							formControlName="ccMe"
							[class.is-invalid]="form?.controls?.ccMe?.dirty && form?.controls?.ccMe?.invalid"
						/>
						<span class="label-text" translate="Labels.CCMe"></span>
					</label>
				</div>
			</div>

			<div class="row">
				<div class="form-group">
					<label class="form-label form-label-required" translate="Labels.BodyMail"></label>
					<textarea
						[class.is-invalid]="bodyField.dirty && bodyField.invalid"
						id="field-body"
						formControlName="body"
						rows="8"
					></textarea>
					<form-control-feedback [field]="bodyField"></form-control-feedback>
				</div>
			</div>
		</form>
	</div>

	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="onClose()">
			<i class="far fa-times"></i>
			{{ 'Actions.Cancel' | translate }}
		</button>
		<button type="button" class="btn btn-primary" (click)="onConfirm()">
			<i class="far fa-save"></i>
			{{ 'Actions.Send' | translate }}
		</button>
	</div>
</content-block>
